export const categories = [
  {
    slug: "redai-haidao",
    name: "热带海岛",
    description: "碧海蓝天、白沙椰林，探索亚洲最美的海岛度假天堂",
    imageUrl: "https://readdy.ai/api/search-image?query=Tropical%20island%20paradise%20with%20crystal%20clear%20turquoise%20water%20white%20sand%20beach%20palm%20trees%20luxury%20resort%20aerial%20view%20Southeast%20Asia%20travel%20destination%20bright%20sunny%20day%20stunning%20natural%20scenery%20calm%20ocean%20waves%20gentle%20breeze%20dreamy%20vacation%20atmosphere%20professional%20travel%20photography&width=800&height=600&seq=cat-island-01&orientation=landscape",
    heroImageUrl: "https://readdy.ai/api/search-image?query=Tropical%20island%20paradise%20with%20crystal%20clear%20turquoise%20water%20white%20sand%20beach%20palm%20trees%20luxury%20resort%20aerial%20view%20Southeast%20Asia%20travel%20destination%20bright%20sunny%20day%20stunning%20natural%20scenery%20calm%20ocean%20waves%20gentle%20breeze%20dreamy%20vacation%20atmosphere%20professional%20travel%20photography&width=1600&height=700&seq=cat-island-01&orientation=landscape",
    icon: "ri-anchor-line",
    count: 28,
  },
  {
    slug: "gulao-wenming",
    name: "古老文明",
    description: "穿越千年时光，探访亚洲最神秘的历史遗迹与文化古城",
    imageUrl: "https://readdy.ai/api/search-image?query=Ancient%20Asian%20temple%20complex%20with%20intricate%20stone%20carvings%20misty%20morning%20atmosphere%20Angkor%20Wat%20style%20architecture%20surrounded%20by%20lush%20jungle%20golden%20sunrise%20light%20mysterious%20spiritual%20vibe%20historic%20civilization%20ruins%20moss%20covered%20stones%20serene%20and%20majestic%20landscape%20travel%20photography&width=800&height=600&seq=cat-ancient-02&orientation=landscape",
    heroImageUrl: "https://readdy.ai/api/search-image?query=Ancient%20Asian%20temple%20complex%20with%20intricate%20stone%20carvings%20misty%20morning%20atmosphere%20Angkor%20Wat%20style%20architecture%20surrounded%20by%20lush%20jungle%20golden%20sunrise%20light%20mysterious%20spiritual%20vibe%20historic%20civilization%20ruins%20moss%20covered%20stones%20serene%20and%20majestic%20landscape%20travel%20photography&width=1600&height=700&seq=cat-ancient-02&orientation=landscape",
    icon: "ri-building-4-line",
    count: 24,
  },
  {
    slug: "xiandai-dushi",
    name: "现代都市",
    description: "霓虹璀璨、摩天大楼，感受亚洲最繁华的国际大都会",
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20Asian%20metropolis%20skyline%20at%20night%20with%20neon%20lights%20skyscrapers%20futuristic%20architecture%20bustling%20city%20streets%20Tokyo%20Shanghai%20Singapore%20vibe%20vibrant%20urban%20energy%20colorful%20illuminated%20billboards%20reflection%20on%20river%20dazzling%20cityscape%20travel%20destination%20photography&width=800&height=600&seq=cat-city-03&orientation=landscape",
    heroImageUrl: "https://readdy.ai/api/search-image?query=Modern%20Asian%20metropolis%20skyline%20at%20night%20with%20neon%20lights%20skyscrapers%20futuristic%20architecture%20bustling%20city%20streets%20Tokyo%20Shanghai%20Singapore%20vibe%20vibrant%20urban%20energy%20colorful%20illuminated%20billboards%20reflection%20on%20river%20dazzling%20cityscape%20travel%20destination%20photography&width=1600&height=700&seq=cat-city-03&orientation=landscape",
    icon: "ri-building-2-line",
    count: 22,
  },
  {
    slug: "ziran-qiguan",
    name: "自然奇观",
    description: "鬼斧神工的大自然杰作，领略亚洲最壮观的自然风光",
    imageUrl: "https://readdy.ai/api/search-image?query=Spectacular%20natural%20wonder%20in%20Asia%20towering%20limestone%20karst%20mountains%20rising%20from%20emerald%20green%20rice%20terraces%20morning%20mist%20dramatic%20landscape%20Guilin%20Halong%20Bay%20style%20scenery%20lush%20vegetation%20winding%20river%20beneath%20cliffs%20golden%20sunlight%20breaking%20through%20clouds%20breathtaking%20natural%20beauty%20travel%20photography&width=800&height=600&seq=cat-nature-04&orientation=landscape",
    heroImageUrl: "https://readdy.ai/api/search-image?query=Spectacular%20natural%20wonder%20in%20Asia%20towering%20limestone%20karst%20mountains%20rising%20from%20emerald%20green%20rice%20terraces%20morning%20mist%20dramatic%20landscape%20Guilin%20Halong%20Bay%20style%20scenery%20lush%20vegetation%20winding%20river%20beneath%20cliffs%20golden%20sunlight%20breaking%20through%20clouds%20breathtaking%20natural%20beauty%20travel%20photography&width=1600&height=700&seq=cat-nature-04&orientation=landscape",
    icon: "ri-landscape-line",
    count: 20,
  },
  {
    slug: "meishi-zhi-lv",
    name: "美食之旅",
    description: "舌尖上的亚洲，从街头小吃到米其林餐厅的美食朝圣",
    imageUrl: "https://readdy.ai/api/search-image?query=Asian%20street%20food%20night%20market%20bustling%20with%20steaming%20food%20stalls%20colorful%20lanterns%20hanging%20above%20delicious%20traditional%20dishes%20dumplings%20noodles%20grilled%20skewers%20local%20chefs%20cooking%20warm%20golden%20lighting%20authentic%20culinary%20experience%20vibrant%20atmosphere%20food%20travel%20photography&width=800&height=600&seq=cat-food-05&orientation=landscape",
    heroImageUrl: "https://readdy.ai/api/search-image?query=Asian%20street%20food%20night%20market%20bustling%20with%20steaming%20food%20stalls%20colorful%20lanterns%20hanging%20above%20delicious%20traditional%20dishes%20dumplings%20noodles%20grilled%20skewers%20local%20chefs%20cooking%20warm%20golden%20lighting%20authentic%20culinary%20experience%20vibrant%20atmosphere%20food%20travel%20photography&width=1600&height=700&seq=cat-food-05&orientation=landscape",
    icon: "ri-restaurant-line",
    count: 18,
  },
  {
    slug: "shechi-dujia",
    name: "奢华度假",
    description: "顶级度假村与私密别墅，享受亚洲最极致的奢华体验",
    imageUrl: "https://readdy.ai/api/search-image?query=Luxury%20overwater%20villa%20resort%20in%20Maldives%20style%20crystal%20clear%20turquoise%20lagoon%20infinity%20pool%20blending%20into%20horizon%20wooden%20deck%20with%20daybeds%20tropical%20sunset%20golden%20hour%20light%20palm%20trees%20silhouette%20elegant%20interior%20visible%20through%20glass%20doors%20serene%20luxurious%20atmosphere%20high%20end%20travel%20photography&width=800&height=600&seq=cat-luxury-06&orientation=landscape",
    heroImageUrl: "https://readdy.ai/api/search-image?query=Luxury%20overwater%20villa%20resort%20in%20Maldives%20style%20crystal%20clear%20turquoise%20lagoon%20infinity%20pool%20blending%20into%20horizon%20wooden%20deck%20with%20daybeds%20tropical%20sunset%20golden%20hour%20light%20palm%20trees%20silhouette%20elegant%20interior%20visible%20through%20glass%20doors%20serene%20luxurious%20atmosphere%20high%20end%20travel%20photography&width=1600&height=700&seq=cat-luxury-06&orientation=landscape",
    icon: "ri-vip-crown-line",
    count: 16,
  },
];

export const articles = [
  {
    slug: "bali-daoyu-dujia-zhinan",
    title: "巴厘岛终极度假指南：从乌布稻田到悬崖寺庙的全攻略",
    category: "redai-haidao",
    excerpt: `巴厘岛，这个被称为「众神之岛」的印尼明珠，以其独特的印度教文化、层层叠叠的梯田、神秘的悬崖寺庙和世界级的海滩而闻名于世。本指南将带你深入探索巴厘岛最迷人的角落。`,
    content: `
      <h2>为什么选择巴厘岛？</h2>
      <p>巴厘岛位于印度尼西亚，是世界上最受欢迎的旅游目的地之一。这里不仅有令人窒息的自然风光，更有深厚的文化底蕴。从乌布的艺术氛围到库塔的冲浪胜地，从金巴兰的浪漫日落到水明漾的时尚生活，巴厘岛能满足每一种旅行者的期待。</p>
      <h2>最佳旅行时间</h2>
      <p>巴厘岛全年温暖，属于热带气候。最佳旅行季节是<strong>4月至10月</strong>的旱季，此时天气晴朗、湿度较低，非常适合海滩活动和户外探险。11月至次年3月为雨季，但通常只是短暂的阵雨，价格也更为实惠。</p>
      <h2>必去景点推荐</h2>
      <h3>1. 海神庙（Tanah Lot）</h3>
      <p>坐落在海边巨岩上的海神庙是巴厘岛最重要的地标之一。涨潮时，寺庙如同漂浮在海上，日落时分景色尤为壮观。建议下午4点左右抵达，捕捉最美的光影瞬间。</p>
      <h3>2. 乌布皇宫与梯田</h3>
      <p>乌布是巴厘岛的文化艺术中心，乌布皇宫展现了精致的巴厘岛传统建筑。不远处的德格拉朗梯田则是Instagram上最热门的打卡地之一，层层叠叠的翠绿稻田令人心旷神怡。</p>
      <h3>3. 乌鲁瓦图悬崖寺</h3>
      <p>这座位于70米高悬崖上的寺庙，可以俯瞰壮丽的印度洋。每天日落时分还有传统的Kecak舞蹈表演，是体验巴厘岛文化的绝佳机会。</p>
      <h2>美食推荐</h2>
      <p>必尝的巴厘岛美食包括：烤乳猪（Babi Guling）、脏鸭餐（Bebek Betutu）、沙爹串烧和各式热带水果。乌布和水明漾地区有众多精致的餐厅和咖啡馆。</p>
      <h2>住宿建议</h2>
      <p>预算充足的旅行者可以选择努沙杜瓦或水明漾的豪华度假村；追求性价比的可以考虑库塔和勒吉安地区；想要深度体验文化的，乌布周边的精品民宿是最佳选择。</p>
    `,
    imageUrl: "https://readdy.ai/api/search-image?query=Bali%20Indonesia%20tropical%20paradise%20with%20ancient%20stone%20temple%20on%20cliff%20overlooking%20ocean%20at%20sunset%20golden%20sky%20dramatic%20waves%20crashing%20below%20lush%20green%20vegetation%20traditional%20Balinese%20architecture%20serene%20spiritual%20atmosphere%20travel%20destination%20photography%20warm%20tones&width=1600&height=800&seq=art-bali-01&orientation=landscape",
    cardImageUrl: "https://readdy.ai/api/search-image?query=Bali%20Indonesia%20tropical%20paradise%20with%20ancient%20stone%20temple%20on%20cliff%20overlooking%20ocean%20at%20sunset%20golden%20sky%20dramatic%20waves%20crashing%20below%20lush%20green%20vegetation%20traditional%20Balinese%20architecture%20serene%20spiritual%20atmosphere%20travel%20destination%20photography%20warm%20tones&width=800&height=500&seq=art-bali-01&orientation=landscape",
    readTime: "12分钟",
    publishDate: "2026-07-15",
    author: "旅行达人小林",
    tags: ["巴厘岛", "海岛度假", "印尼旅游", "蜜月旅行"],
  },
  {
    slug: "jingdu-gulao-sheyuan-zhinan",
    title: "京都古寺巡礼：在千年庭院中寻找日本美学精髓",
    category: "gulao-wenming",
    excerpt: `京都，这座拥有千年历史的日本古都，保存着超过2000座寺庙和神社。从金阁寺的璀璨到龙安寺枯山水的禅意，每一处都是日本传统美学的完美诠释。`,
    content: `
      <h2>京都——日本的心灵故乡</h2>
      <p>京都是日本最具历史底蕴的城市，作为日本首都超过一千年。这座城市完美地保存了日本传统文化的精髓，从精致的庭院设计到古老的茶道仪式，每一个角落都散发着独特的东方魅力。</p>
      <h2>最佳游览季节</h2>
      <p>京都四季分明，每个季节都有不同的美。<strong>春季（3-4月）</strong>的樱花和<strong>秋季（11月）</strong>的红叶是最佳游览时间。冬季游客较少，雪中的金阁寺别有一番风味。夏季虽然炎热，但7月的祇园祭是日本三大祭典之一，值得体验。</p>
      <h2>不可错过的寺庙</h2>
      <h3>1. 金阁寺（鹿苑寺）</h3>
      <p>金阁寺是京都最著名的地标，整座建筑覆盖着金箔，倒映在镜湖池中，堪称完美的画面。建议清晨前往，避开人潮。</p>
      <h3>2. 龙安寺</h3>
      <p>龙安寺的枯山水石庭是日本禅宗美学的巅峰之作。15块石头无论从哪个角度都无法同时看到全部，充满了哲学意蕴。</p>
      <h3>3. 伏见稻荷大社</h3>
      <p>绵延至山顶的千本鸟居是京都最令人震撼的景观之一。红色的鸟居隧道如同穿越时空的通道，建议清晨或傍晚前往以获得最佳拍摄效果。</p>
      <h2>文化体验</h2>
      <p>在京都可以体验茶道、和服变装、坐禅冥想等传统日本文化活动。花见小路附近的祇园区域还有机会遇到真正的艺伎。</p>
    `,
    imageUrl: "https://readdy.ai/api/search-image?query=Kyoto%20Japan%20ancient%20temple%20with%20golden%20pavilion%20reflecting%20in%20still%20pond%20surrounded%20by%20maple%20trees%20in%20autumn%20colors%20red%20orange%20gold%20traditional%20Japanese%20garden%20zen%20atmosphere%20morning%20mist%20serene%20tranquil%20historic%20architecture%20travel%20photography&width=1600&height=800&seq=art-kyoto-02&orientation=landscape",
    cardImageUrl: "https://readdy.ai/api/search-image?query=Kyoto%20Japan%20ancient%20temple%20with%20golden%20pavilion%20reflecting%20in%20still%20pond%20surrounded%20by%20maple%20trees%20in%20autumn%20colors%20red%20orange%20gold%20traditional%20Japanese%20garden%20zen%20atmosphere%20morning%20mist%20serene%20tranquil%20historic%20architecture%20travel%20photography&width=800&height=500&seq=art-kyoto-02&orientation=landscape",
    readTime: "10分钟",
    publishDate: "2026-07-10",
    author: "文化探索者阿明",
    tags: ["京都", "日本旅游", "古寺", "文化之旅"],
  },
  {
    slug: "pujidao-haidao-dujia-gonglue",
    title: "普吉岛海岛度假全攻略：从芭东海滩到攀牙湾跳岛游",
    category: "redai-haidao",
    excerpt: `泰国普吉岛是安达曼海上的一颗明珠，拥有碧蓝的海水、洁白的沙滩和丰富的夜生活。这篇攻略将带你玩转普吉岛最精华的景点和体验。`,
    content: `
      <h2>普吉岛——安达曼海上的明珠</h2>
      <p>普吉岛是泰国最大的岛屿，也是东南亚最热门的度假胜地之一。这里有世界级的海滩、丰富的海上活动和充满活力的夜生活，是放松身心的完美目的地。</p>
      <h2>最佳旅行时间</h2>
      <p>普吉岛的最佳旅行季节是<strong>11月至次年4月</strong>，这段时间天气晴朗、海水清澈，非常适合潜水和浮潜。5月至10月是雨季，但降雨通常集中在下午，价格也更实惠。</p>
      <h2>必游景点</h2>
      <h3>1. 攀牙湾</h3>
      <p>被誉为「海上桂林」的攀牙湾，以奇特的石灰岩岛屿和碧绿的海水闻名。詹姆斯·邦德岛是这里最著名的地标，可以乘坐长尾船或皮划艇探索隐藏的洞穴和泻湖。</p>
      <h3>2. 皮皮岛</h3>
      <p>因电影《海滩》而闻名全球的皮皮岛，拥有令人窒息的海湾和清澈见底的海水。玛雅湾是必打卡之地，建议参加一日游团。</p>
      <h3>3. 查龙寺</h3>
      <p>普吉岛最大的佛教寺庙，建筑精美，香火鼎盛。寺内有一座60米高的佛塔，据说藏有佛祖的舍利子。</p>
      <h2>美食推荐</h2>
      <p>普吉岛的美食融合了泰国南部特色，必尝的有：冬阴功汤、绿咖喱、泰式炒河粉、芒果糯米饭和新鲜的海鲜烧烤。</p>
    `,
    imageUrl: "https://readdy.ai/api/search-image?query=Phuket%20Thailand%20tropical%20beach%20paradise%20with%20turquoise%20clear%20water%20white%20sand%20beach%20limestone%20karst%20islands%20in%20distance%20longtail%20boats%20floating%20on%20calm%20sea%20blue%20sky%20with%20fluffy%20clouds%20palm%20trees%20lining%20shore%20vibrant%20tropical%20travel%20photography&width=1600&height=800&seq=art-phuket-03&orientation=landscape",
    cardImageUrl: "https://readdy.ai/api/search-image?query=Phuket%20Thailand%20tropical%20beach%20paradise%20with%20turquoise%20clear%20water%20white%20sand%20beach%20limestone%20karst%20islands%20in%20distance%20longtail%20boats%20floating%20on%20calm%20sea%20blue%20sky%20with%20fluffy%20clouds%20palm%20trees%20lining%20shore%20vibrant%20tropical%20travel%20photography&width=800&height=500&seq=art-phuket-03&orientation=landscape",
    readTime: "8分钟",
    publishDate: "2026-06-28",
    author: "海岛控小美",
    tags: ["普吉岛", "泰国旅游", "海岛度假", "跳岛游"],
  },
  {
    slug: "dongjing-shechi-lvxing-zhinan",
    title: "东京奢华旅行指南：从银座购物到米其林餐厅的顶级体验",
    category: "xiandai-dushi",
    excerpt: `东京，这座永不停歇的超级都市，是传统与未来的完美融合。从世界顶级的购物体验到米其林星级餐厅，东京能满足你对奢华旅行的所有想象。`,
    content: `
      <h2>东京——传统与未来的交汇点</h2>
      <p>东京是世界上最具活力的城市之一，这里既有千年历史的古老寺庙，也有未来感十足的摩天大楼。作为全球米其林餐厅最多的城市，东京也是美食爱好者的终极朝圣地。</p>
      <h2>奢华购物体验</h2>
      <h3>1. 银座</h3>
      <p>银座是东京最高档的购物区，汇集了爱马仕、香奈儿、路易威登等顶级品牌的旗舰店。周末的主干道会变成步行街，可以悠闲地漫步购物。</p>
      <h3>2. 表参道</h3>
      <p>这条被榉树林荫覆盖的大道被称为东京的香榭丽舍，两旁是建筑大师设计的精品店和时尚买手店。</p>
      <h2>米其林美食之旅</h2>
      <p>东京拥有超过200家米其林星级餐厅。从寿司之神小野二郎的数寄屋桥次郎，到龙吟的分子料理，每一餐都是一场艺术盛宴。建议提前1-3个月预订。</p>
      <h2>高端住宿推荐</h2>
      <p>安缦东京、虹夕诺雅东京和半岛酒店都是东京顶级的住宿选择，提供无与伦比的日式待客之道。</p>
    `,
    imageUrl: "https://readdy.ai/api/search-image?query=Tokyo%20Japan%20modern%20luxury%20cityscape%20at%20night%20with%20neon%20lights%20Shinjuku%20skyscrapers%20illuminated%20streets%20bustling%20with%20people%20high%20end%20shopping%20district%20Ginza%20style%20sophisticated%20urban%20atmosphere%20reflections%20on%20wet%20pavement%20vibrant%20energy%20travel%20photography&width=1600&height=800&seq=art-tokyo-04&orientation=landscape",
    cardImageUrl: "https://readdy.ai/api/search-image?query=Tokyo%20Japan%20modern%20luxury%20cityscape%20at%20night%20with%20neon%20lights%20Shinjuku%20skyscrapers%20illuminated%20streets%20bustling%20with%20people%20high%20end%20shopping%20district%20Ginza%20style%20sophisticated%20urban%20atmosphere%20reflections%20on%20wet%20pavement%20vibrant%20energy%20travel%20photography&width=800&height=500&seq=art-tokyo-04&orientation=landscape",
    readTime: "9分钟",
    publishDate: "2026-06-20",
    author: "城市漫游者杰克",
    tags: ["东京", "日本旅游", "奢华旅行", "米其林"],
  },
  {
    slug: "xiaweiyi-ziran-tanxian",
    title: "夏威夷自然探险之旅：火山国家公园与秘境瀑布徒步",
    category: "ziran-qiguan",
    excerpt: `夏威夷不仅是度假天堂，更是自然爱好者的乐园。从活火山到热带雨林，从黑沙滩到隐秘瀑布，夏威夷的自然奇观令人叹为观止。`,
    content: `
      <h2>夏威夷——太平洋上的自然奇迹</h2>
      <p>夏威夷群岛由火山喷发形成，独特的地质构造孕育了世界上最壮观的自然景观。夏威夷火山国家公园是联合国教科文组织世界遗产，也是地球上少数可以近距离观赏活火山的地方之一。</p>
      <h2>火山国家公园</h2>
      <p>基拉韦厄火山是世界上最活跃的火山之一，已经持续喷发超过30年。游客可以沿着火山口边缘步道徒步，观赏壮观的火山口和翻滚的岩浆。入夜后，火红的岩浆映照天空，景象令人终身难忘。</p>
      <h2>秘境瀑布徒步</h2>
      <p>夏威夷各岛都有众多隐秘的瀑布等待探索。可爱岛的纳帕利海岸有着令人震撼的悬崖和瀑布，茂宜岛的哈纳公路沿途有数十个值得停留的瀑布和天然泳池。</p>
      <h2>独特地貌</h2>
      <p>大岛的黑沙滩和绿沙滩是火山活动的直接产物，普纳鲁吾黑沙滩还是濒危海龟的栖息地。哈雷阿卡拉国家公园的火山口地貌如同月球表面，日出时分尤为壮观。</p>
    `,
    imageUrl: "https://readdy.ai/api/search-image?query=Hawaii%20Big%20Island%20volcano%20national%20park%20dramatic%20landscape%20with%20red%20glowing%20lava%20flowing%20into%20ocean%20at%20dusk%20steam%20rising%20against%20dark%20sky%20jagged%20volcanic%20rock%20formations%20powerful%20natural%20forces%20raw%20earth%20energy%20epic%20adventure%20travel%20photography&width=1600&height=800&seq=art-hawaii-05&orientation=landscape",
    cardImageUrl: "https://readdy.ai/api/search-image?query=Hawaii%20Big%20Island%20volcano%20national%20park%20dramatic%20landscape%20with%20red%20glowing%20lava%20flowing%20into%20ocean%20at%20dusk%20steam%20rising%20against%20dark%20sky%20jagged%20volcanic%20rock%20formations%20powerful%20natural%20forces%20raw%20earth%20energy%20epic%20adventure%20travel%20photography&width=800&height=500&seq=art-hawaii-05&orientation=landscape",
    readTime: "11分钟",
    publishDate: "2026-06-12",
    author: "户外探险家大伟",
    tags: ["夏威夷", "火山", "徒步", "自然奇观"],
  },
  {
    slug: "xinjiapo-meishi-tujian",
    title: "新加坡美食图鉴：从米其林路边摊到娘惹私房菜",
    category: "meishi-zhi-lv",
    excerpt: `新加坡是亚洲美食的大熔炉，中华料理、马来风味、印度香料和娘惹美食在这里完美融合。跟着这份美食地图，吃遍狮城最地道的美味。`,
    content: `
      <h2>新加坡——亚洲美食大熔炉</h2>
      <p>新加坡虽然国土面积不大，却是全球美食密度最高的城市之一。这里不仅有获得米其林星级的路边摊，还有传承百年的家族餐厅和融合创新的现代料理。</p>
      <h2>必吃美食清单</h2>
      <h3>1. 海南鸡饭</h3>
      <p>新加坡的国民美食，嫩滑的白切鸡搭配鸡油饭，配上特制的辣椒酱、姜蓉和黑酱油。推荐天天海南鸡饭（麦士威熟食中心）和了凡油鸡饭面（全球最便宜的米其林星级餐厅）。</p>
      <h3>2. 辣椒螃蟹</h3>
      <p>新加坡最具代表性的海鲜料理，肥美的螃蟹配上香辣酸甜的酱汁，用炸馒头蘸着吃是经典吃法。珍宝海鲜楼和无招牌海鲜是最知名的两家。</p>
      <h3>3. 叻沙</h3>
      <p>浓郁的椰浆咖喱汤底配上米粉、虾仁、鱼饼和蛤蜊，是娘惹美食的代表。加东叻沙使用切短的米粉，可以用勺子直接舀着吃。</p>
      <h3>4. 肉骨茶</h3>
      <p>用多种药材和香料熬制的猪骨汤，分为潮州式的清汤和福建式的黑汤两种。配油条一起吃是当地人的最爱。</p>
      <h2>美食区域推荐</h2>
      <p>牛车水（唐人街）适合寻找中华美食；小印度有最地道的印度料理；甘榜格南则可以品尝马来和阿拉伯风味。各个熟食中心（Hawker Centre）是性价比最高的美食聚集地。</p>
    `,
    imageUrl: "https://readdy.ai/api/search-image?query=Singapore%20hawker%20center%20food%20paradise%20with%20rows%20of%20food%20stalls%20steaming%20hot%20dishes%20colorful%20signage%20locals%20enjoying%20meals%20Hainanese%20chicken%20rice%20chilli%20crab%20laksa%20variety%20of%20Asian%20cuisine%20vibrant%20bustling%20atmosphere%20warm%20lighting%20authentic%20street%20food%20photography&width=1600&height=800&seq=art-singapore-06&orientation=landscape",
    cardImageUrl: "https://readdy.ai/api/search-image?query=Singapore%20hawker%20center%20food%20paradise%20with%20rows%20of%20food%20stalls%20steaming%20hot%20dishes%20colorful%20signage%20locals%20enjoying%20meals%20Hainanese%20chicken%20rice%20chilli%20crab%20laksa%20variety%20of%20Asian%20cuisine%20vibrant%20bustling%20atmosphere%20warm%20lighting%20authentic%20street%20food%20photography&width=800&height=500&seq=art-singapore-06&orientation=landscape",
    readTime: "10分钟",
    publishDate: "2026-06-05",
    author: "美食猎人小悦",
    tags: ["新加坡", "美食之旅", "路边摊", "米其林"],
  },
  {
    slug: "maerdaifu-shechi-dujia",
    title: "马尔代夫极致奢华度假：水上别墅与私人岛屿体验",
    category: "shechi-dujia",
    excerpt: `马尔代夫是全球最顶级的奢华度假目的地之一，一岛一酒店的概念让每一次入住都成为独一无二的体验。从水上别墅到海底餐厅，马尔代夫定义了奢华旅行的新高度。`,
    content: `
      <h2>马尔代夫——印度洋上的珍珠项链</h2>
      <p>马尔代夫由1192个珊瑚岛组成，其中约200个岛屿有人居住，超过150个岛屿被开发为度假村。这里拥有世界上最清澈的海水、最细软的白沙和最丰富的海洋生物。</p>
      <h2>选岛攻略</h2>
      <p>马尔代夫有众多奢华度假村，如何选择适合自己的岛屿是关键。索尼娃贾尼的水上滑梯别墅是社交媒体的网红打卡地；白马庄园以极致服务和米其林餐饮著称；维拉私人岛则是追求私密性的最佳选择。</p>
      <h2>奢华体验</h2>
      <h3>1. 水上别墅</h3>
      <p>马尔代夫的水上别墅是奢华旅行的标志。从房间可以直接跳入清澈的泻湖，躺在私人泳池中欣赏无尽的印度洋日落。</p>
      <h3>2. 水下餐厅</h3>
      <p>康莱德酒店的Ithaa是全球第一家全玻璃水下餐厅，在用餐的同时可以欣赏珊瑚礁和海洋生物。尼亚玛的Subsix则位于海面下6米。</p>
      <h3>3. 私人游艇出海</h3>
      <p>可以租用私人游艇进行日落巡航、海豚观赏或前往无人岛野餐。</p>
      <h2>最佳旅行时间</h2>
      <p>马尔代夫全年适合旅行，但<strong>11月至次年4月</strong>的干季天气最好，海水能见度最高。5月至10月是雨季，价格有较大折扣，阵雨通常不会持续太久。</p>
    `,
    imageUrl: "https://readdy.ai/api/search-image?query=Maldives%20luxury%20overwater%20villa%20with%20private%20infinity%20pool%20crystal%20clear%20turquoise%20lagoon%20wooden%20deck%20with%20sunbeds%20tropical%20sunset%20golden%20orange%20sky%20gentle%20waves%20palm%20trees%20on%20distant%20island%20pure%20luxury%20serene%20paradise%20high%20end%20travel%20photography&width=1600&height=800&seq=art-maldives-07&orientation=landscape",
    cardImageUrl: "https://readdy.ai/api/search-image?query=Maldives%20luxury%20overwater%20villa%20with%20private%20infinity%20pool%20crystal%20clear%20turquoise%20lagoon%20wooden%20deck%20with%20sunbeds%20tropical%20sunset%20golden%20orange%20sky%20gentle%20waves%20palm%20trees%20on%20distant%20island%20pure%20luxury%20serene%20paradise%20high%20end%20travel%20photography&width=800&height=500&seq=art-maldives-07&orientation=landscape",
    readTime: "9分钟",
    publishDate: "2026-05-28",
    author: "奢华旅行家安娜",
    tags: ["马尔代夫", "奢华度假", "水上别墅", "蜜月"],
  },
  {
    slug: "wugeku-shenmi-yiji",
    title: "吴哥窟探秘：在千年废墟中追寻高棉王朝的辉煌",
    category: "gulao-wenming",
    excerpt: `柬埔寨的吴哥窟是世界上最大的宗教建筑群，也是高棉王朝留给世界的最伟大遗产。在晨光中漫步于千年废墟之间，感受历史的厚重与神秘。`,
    content: `
      <h2>吴哥窟——失落的文明</h2>
      <p>吴哥窟是12世纪高棉王朝苏利耶跋摩二世修建的印度教寺庙，后来逐渐转变为佛教圣地。整个建筑群占地约400平方公里，包含数百座寺庙和水利工程，展现了古代高棉人惊人的建筑智慧。</p>
      <h2>游览路线推荐</h2>
      <p>经典的游览路线分为<strong>小圈、大圈和外圈</strong>。小圈包括吴哥窟、巴戎寺和塔普伦寺等精华景点；大圈涵盖了圣剑寺、涅槃宫等；外圈则包括女王宫和崩密列等较远的寺庙。建议至少安排3天时间。</p>
      <h2>必看景点</h2>
      <h3>1. 吴哥窟日出</h3>
      <p>在莲花池前等待吴哥窟的日出是每个人一生中值得拥有的体验。当太阳从寺庙后方升起，五座塔尖在晨光中呈现出金色的轮廓，美得令人窒息。</p>
      <h3>2. 巴戎寺——高棉的微笑</h3>
      <p>巴戎寺以其54座四面佛塔上的216张「高棉的微笑」而闻名。这些神秘的微笑面容据说以阇耶跋摩七世为原型，无论从哪个角度都似乎在注视着你。</p>
      <h3>3. 塔普伦寺</h3>
      <p>因电影《古墓丽影》而闻名，巨大的榕树根系与寺庙建筑纠缠交融，展现了自然力量与人类文明的奇妙共存。</p>
    `,
    imageUrl: "https://readdy.ai/api/search-image?query=Angkor%20Wat%20Cambodia%20ancient%20temple%20complex%20at%20sunrise%20silhouette%20of%20five%20towers%20reflecting%20in%20still%20lotus%20pond%20golden%20orange%20sky%20with%20pink%20clouds%20mysterious%20atmosphere%20ancient%20stone%20carvings%20spiritual%20serene%20historic%20civilization%20travel%20photography&width=1600&height=800&seq=art-angkor-08&orientation=landscape",
    cardImageUrl: "https://readdy.ai/api/search-image?query=Angkor%20Wat%20Cambodia%20ancient%20temple%20complex%20at%20sunrise%20silhouette%20of%20five%20towers%20reflecting%20in%20still%20lotus%20pond%20golden%20orange%20sky%20with%20pink%20clouds%20mysterious%20atmosphere%20ancient%20stone%20carvings%20spiritual%20serene%20historic%20civilization%20travel%20photography&width=800&height=500&seq=art-angkor-08&orientation=landscape",
    readTime: "11分钟",
    publishDate: "2026-05-20",
    author: "历史迷小陈",
    tags: ["吴哥窟", "柬埔寨", "古迹", "文化遗产"],
  },
  {
    slug: "shouer-chaoliu-shenghuo",
    title: "首尔潮流生活指南：从弘大到江南的K-Culture之旅",
    category: "xiandai-dushi",
    excerpt: `首尔是亚洲潮流文化的中心，K-POP、韩剧、美妆和时尚从这里席卷全球。跟随这份指南，探索首尔最具活力的潮流街区和文化热点。`,
    content: `
      <h2>首尔——K-Culture的全球发源地</h2>
      <p>首尔是一座充满活力的超级都市，K-POP文化、韩剧取景地、时尚美妆和街头美食在这里完美融合。无论是追星族还是美食爱好者，首尔都能让你流连忘返。</p>
      <h2>潮流街区</h2>
      <h3>1. 弘大</h3>
      <p>弘益大学周边是首尔最年轻、最具活力的区域。街头表演、独立咖啡馆、潮流服饰店和夜店文化让这里24小时充满能量。</p>
      <h3>2. 江南</h3>
      <p>江南区是首尔的高端商业区，林荫道两旁汇集了设计师品牌店、医美诊所和精致餐厅。这里也是偶遇明星的高频区域。</p>
      <h3>3. 明洞</h3>
      <p>明洞是首尔最著名的购物区，化妆品店、时尚品牌和街头小吃摊位鳞次栉比。许多店铺提供中文服务，深受中国游客喜爱。</p>
      <h2>K-POP体验</h2>
      <p>SM娱乐和JYP娱乐等经纪公司大楼是粉丝必去的打卡地。COEX的SMTOWN博物馆可以深入了解K-POP文化。运气好的话还可以参加音乐银行的现场录制。</p>
    `,
    imageUrl: "https://readdy.ai/api/search-image?query=Seoul%20South%20Korea%20modern%20trendy%20neighborhood%20with%20colorful%20neon%20signs%20fashionable%20young%20people%20walking%20on%20busy%20street%20cafes%20and%20boutiques%20Kpop%20billboards%20urban%20vibrant%20energy%20night%20scene%20stylish%20atmosphere%20travel%20destination%20photography&width=1600&height=800&seq=art-seoul-09&orientation=landscape",
    cardImageUrl: "https://readdy.ai/api/search-image?query=Seoul%20South%20Korea%20modern%20trendy%20neighborhood%20with%20colorful%20neon%20signs%20fashionable%20young%20people%20walking%20on%20busy%20street%20cafes%20and%20boutiques%20Kpop%20billboards%20urban%20vibrant%20energy%20night%20scene%20stylish%20atmosphere%20travel%20destination%20photography&width=800&height=500&seq=art-seoul-09&orientation=landscape",
    readTime: "8分钟",
    publishDate: "2026-05-15",
    author: "潮流达人小希",
    tags: ["首尔", "韩国旅游", "K-POP", "潮流"],
  },
];

export const featuredDestinations = [
  {
    slug: "bali",
    name: "巴厘岛",
    englishName: "Bali",
    country: "印度尼西亚",
    description: "众神之岛，热带天堂",
    imageUrl: "https://readdy.ai/api/search-image?query=Bali%20Indonesia%20iconic%20rice%20terraces%20in%20Ubud%20with%20palm%20trees%20traditional%20Balinese%20temple%20gate%20in%20foreground%20lush%20green%20vegetation%20morning%20golden%20light%20peaceful%20atmosphere%20tropical%20paradise%20travel%20destination%20photography&width=800&height=600&seq=dest-bali-01&orientation=landscape",
    rating: 4.8,
    articleCount: 12,
    categorySlug: "redai-haidao",
  },
  {
    slug: "kyoto",
    name: "京都",
    englishName: "Kyoto",
    country: "日本",
    description: "千年古都，禅意之美",
    imageUrl: "https://readdy.ai/api/search-image?query=Kyoto%20Japan%20traditional%20wooden%20machiya%20houses%20along%20cobblestone%20street%20with%20cherry%20blossom%20trees%20in%20full%20bloom%20soft%20pink%20petals%20falling%20historic%20atmosphere%20maiko%20in%20kimono%20walking%20in%20distance%20spring%20morning%20light%20romantic%20travel%20photography&width=800&height=600&seq=dest-kyoto-02&orientation=landscape",
    rating: 4.9,
    articleCount: 10,
    categorySlug: "gulao-wenming",
  },
  {
    slug: "maldives",
    name: "马尔代夫",
    englishName: "Maldives",
    country: "马尔代夫",
    description: "印度洋明珠，蜜月天堂",
    imageUrl: "https://readdy.ai/api/search-image?query=Maldives%20aerial%20view%20of%20circular%20coral%20atoll%20with%20overwater%20villas%20arranged%20in%20perfect%20arc%20turquoise%20shallow%20lagoon%20gradient%20to%20deep%20blue%20ocean%20white%20sandbars%20visible%20under%20surface%20palm%20trees%20dotting%20small%20islands%20paradise%20travel%20photography&width=800&height=600&seq=dest-maldives-03&orientation=landscape",
    rating: 4.9,
    articleCount: 8,
    categorySlug: "redai-haidao",
  },
  {
    slug: "tokyo",
    name: "东京",
    englishName: "Tokyo",
    country: "日本",
    description: "传统与未来的交汇点",
    imageUrl: "https://readdy.ai/api/search-image?query=Tokyo%20Japan%20Shibuya%20crossing%20at%20dusk%20hundreds%20of%20people%20crossing%20famous%20scramble%20intersection%20giant%20neon%20billboards%20and%20video%20screens%20glowing%20modern%20urban%20energy%20light%20rain%20creating%20reflections%20on%20pavement%20iconic%20cityscape%20travel%20photography&width=800&height=600&seq=dest-tokyo-04&orientation=landscape",
    rating: 4.7,
    articleCount: 15,
    categorySlug: "xiandai-dushi",
  },
  {
    slug: "phuket",
    name: "普吉岛",
    englishName: "Phuket",
    country: "泰国",
    description: "安达曼海上的明珠",
    imageUrl: "https://readdy.ai/api/search-image?query=Phuket%20Thailand%20beautiful%20tropical%20beach%20with%20crystal%20clear%20turquoise%20water%20white%20sand%20limestone%20rock%20formations%20jutting%20from%20sea%20longtail%20boats%20anchored%20near%20shore%20palm%20trees%20swaying%20in%20breeze%20bright%20sunny%20day%20travel%20photography&width=800&height=600&seq=dest-phuket-05&orientation=landscape",
    rating: 4.6,
    articleCount: 10,
    categorySlug: "redai-haidao",
  },
  {
    slug: "seoul",
    name: "首尔",
    englishName: "Seoul",
    country: "韩国",
    description: "K-Culture潮流中心",
    imageUrl: "https://readdy.ai/api/search-image?query=Seoul%20South%20Korea%20Gyeongbokgung%20Palace%20traditional%20Korean%20architecture%20with%20colorful%20dancheong%20patterns%20people%20wearing%20hanbok%20traditional%20clothing%20autumn%20foliage%20in%20background%20with%20modern%20skyscrapers%20visible%20beyond%20walls%20beautiful%20contrast%20travel%20photography&width=800&height=600&seq=dest-seoul-06&orientation=landscape",
    rating: 4.7,
    articleCount: 9,
    categorySlug: "xiandai-dushi",
  },
];

export const aboutInfo = {
  brandName: "亚洲天堂",
  brandIntro: `亚洲天堂成立于2018年，是一支由资深旅行家和内容创作者组成的团队。我们走遍亚洲每一个角落，只为发现那些令人心动的旅行目的地，并将最真实的旅行体验分享给每一位热爱探索的你。`,
  mission: `我们的使命是让每一次亚洲旅行都成为难忘的回忆。通过精心策划的旅行攻略、真实的体验分享和专业的旅行建议，帮助旅行者发现亚洲最美的一面。`,
  story: [
    {
      year: "2018",
      title: "梦想起航",
      description: `三位热爱亚洲旅行的背包客在巴厘岛的一间咖啡馆里创立了亚洲天堂。最初的梦想很简单：把走过的路、看过的风景、吃过的美食记录下来，分享给更多热爱旅行的人。`,
    },
    {
      year: "2019",
      title: "快速成长",
      description: `团队成员扩展到10人，覆盖了东南亚、东亚和南亚的30多个目的地。网站月访问量突破50万，成为中文旅行社区的新兴力量。`,
    },
    {
      year: "2020",
      title: "内容深耕",
      description: `深入挖掘每个目的地的文化和故事，推出深度旅行攻略系列。与各地旅游局和高端度假村建立合作关系，为用户提供独家旅行体验。`,
    },
    {
      year: "2022",
      title: "全面升级",
      description: `网站全面升级，推出视频攻略和互动地图功能。开设「旅行达人」专栏，邀请知名旅行博主分享独家旅行经验。`,
    },
    {
      year: "2024",
      title: "亚洲领先",
      description: `成为亚洲旅游攻略领域的领先平台，累计服务超过500万旅行者。推出个性化旅行规划服务，为用户量身定制专属亚洲旅行路线。`,
    },
  ],
  reputation: [
    {
      name: "张女士",
      avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%20warm%20smile%20clean%20white%20background%20headshot%20photography&width=100&height=100&seq=avatar-zhang&orientation=squarish",
      location: "上海",
      comment: `根据亚洲天堂的攻略去了巴厘岛，每一个推荐都非常靠谱！乌布的梯田和悬崖日落超出预期，会继续关注。`,
      rating: 5,
      date: "2026-07-20",
    },
    {
      name: "李先生",
      avatar: "https://readdy.ai/api/search-image?query=Chinese%20man%20portrait%20friendly%20expression%20clean%20white%20background%20headshot%20photography&width=100&height=100&seq=avatar-li&orientation=squarish",
      location: "北京",
      comment: `京都古寺巡礼那篇攻略写得非常详细，跟着推荐的路线走完全不会踩雷。回来后还推荐给了身边的朋友。`,
      rating: 5,
      date: "2026-07-18",
    },
    {
      name: "王女士",
      avatar: "https://readdy.ai/api/search-image?query=Asian%20woman%20portrait%20elegant%20smile%20clean%20white%20background%20headshot%20photography&width=100&height=100&seq=avatar-wang&orientation=squarish",
      location: "广州",
      comment: `新加坡美食图鉴拯救了我的选择困难症！海南鸡饭和辣椒螃蟹都太赞了，感谢这么用心的内容。`,
      rating: 5,
      date: "2026-07-15",
    },
    {
      name: "陈先生",
      avatar: "https://readdy.ai/api/search-image?query=Chinese%20man%20portrait%20professional%20confident%20clean%20white%20background%20headshot%20photography&width=100&height=100&seq=avatar-chen&orientation=squarish",
      location: "深圳",
      comment: `通过亚洲天堂找到了马尔代夫最合适的岛屿，蜜月旅行完美无缺。现在已经成为忠实用户，每次出行前必看。`,
      rating: 5,
      date: "2026-07-12",
    },
  ],
  contact: {
    email: "hello@yazhoutiantang.com",
    phone: "+86 400-888-0000",
    wechat: "AsiaParadise_Official",
    weibo: "@亚洲天堂旅行",
    address: "中国上海市浦东新区世纪大道100号环球金融中心28层",
  },
};

export const FAQData = [
  {
    question: "亚洲天堂提供哪些旅行服务？",
    answer: `亚洲天堂专注于提供亚洲地区的旅行攻略和目的地推荐。我们覆盖30+亚洲国家和地区，提供包括热门景点、美食地图、住宿推荐、交通指南和行程规划在内的全方位旅行内容。`,
  },
  {
    question: "如何选择适合自己的亚洲旅行目的地？",
    answer: `你可以根据旅行偏好浏览我们的分类页面：热带海岛适合度假放松，古老文明适合文化探索，现代都市适合购物美食，自然奇观适合户外探险。每篇文章都提供详细的最佳旅行时间和预算建议。`,
  },
  {
    question: "亚洲天堂的内容是否可靠和及时更新？",
    answer: `我们的内容由资深旅行家和当地达人共同创作，所有攻略均基于真实旅行体验。团队定期回顾和更新内容，确保信息的准确性和时效性。`,
  },
  {
    question: "可以在亚洲天堂预订酒店和机票吗？",
    answer: `亚洲天堂目前专注于旅行内容创作和攻略分享，暂不直接提供预订服务。但我们在每篇攻略中都会推荐优质的住宿和交通选项，并提供相关预订平台的参考链接。`,
  },
  {
    question: "如何联系亚洲天堂团队？",
    answer: `你可以通过关于我们页面上的联系方式与我们取得联系，包括邮箱、微信和微博。我们欢迎旅行建议、合作洽谈和内容投稿。`,
  },
];